module.exports = __webpack_public_path__ + "img/target-and-arrow-svgrepo-com.7c358dfc.svg";